module.exports = __webpack_public_path__ + "static/media/kashyap.8b3110fc.jpg";